import FormData from "form-data";
import Mailgun from "mailgun.js";
import { Config } from "../config";
import type { MailgunMessageData, MessagesSendResult } from "mailgun.js/definitions";
import type { FormBaseInstance } from "./Forms";
import type { Address, TFormValues } from "../types";
import { EnvironmentUtils } from "./EnvironmentUtils";

class Mailer {
  private mailgun: Mailgun;
  private mg;

  constructor () {

    this.mailgun = new Mailgun(FormData);

    this.mg = this.mailgun.client({
      username: Config.mailgun_api_user || "api",
      key: Config.mailgun_api_key || "API_KEY",
      // url: "https://api.eu.mailgun.net",
    });
  }

  async sendEmail(messageData: MailgunMessageData): Promise<MessagesSendResult | Error> {
    try {
      const data = await this.mg.messages.create(
        Config.mailgun_domain as string, {
        ...messageData,
        from: messageData.from ?? `Puga&Asociados <${Config.mailgun_smtp_user}>`,
        to: messageData.to ?? Config.owner_emails as string[],
      });

      console.log("Email sent successfully:", data);
      return data;
    } catch (error) {
      console.error("Error sending email:", error);
      return error as Error;
    }
  }

  public formatEmailBodyFromForm<K extends FormBaseInstance, F extends Address>(form: TFormValues & K & F): string {
    const commonMssgPart = String.raw`
    <main>
      <h1>${form.name} ha solicitado una cotización!.</h1><br>
      <section>
        ${this.parseForm(form)}
      </section>
    </main>`;
    return commonMssgPart;
  }

  private parseForm<F extends Address, K extends TFormValues>(form: TFormValues & K & F & { type?: string; }): string {
    return String.raw`
    <article>
      <p>Tipo de Seguro: ${EnvironmentUtils.translateToSpanish(form.type ?? "", true)}</p>
      <p>Datos de tu cliente:</p>
      <ul>
      ${Object.entries(form)
        .filter(([, value]) =>
          value !== undefined
          && value !== null
          && typeof value !== 'object'
          && value !== "on"
          && value !== "off")
        .map(([key, value]) =>
          `<li>
            <strong>
              ${EnvironmentUtils.
            translateToSpanish(
              key ?? "", true)}:
            </strong>
            <em>
              ${EnvironmentUtils.
            translateToSpanish(
              JSON.stringify(value),
              true)?.
            replace(/"/g, '')}
            </em>
          </li>`)
        .join(' ')}
      </ul>
    </article>`;
  }
}

declare type Mail = Mailer;
const mailer: Mail = new Mailer();

export type { Mail };
export { mailer };